// Generated by GitHub Copilot
import SsoApi from '#core/api/auth/SsoApi.ts'
import type { SsoProvider } from '#core/auth/authentication-provider.ts'
import { safeInAppPath } from '#core/auth/enter-app.ts'

const RETURN_KEY = 'ynt-sso-return'
const LINKED_KEY = 'ynt-sso-linked'

/** Where an SSO round trip continues once `/sso/{provider}/callback` has the session. */
export interface SsoReturn {
  /** `link` connects the provider's account to the user who started it; `signIn` signs someone in. */
  kind: 'signIn' | 'link'
  /** In-app path to open afterwards. */
  destination: string
}

const ssoApi = new SsoApi()

/** Sends the browser to `provider` to sign in, landing on `destination` afterwards. Throws when the backend cannot start it. */
export async function startSsoSignIn(provider: SsoProvider, destination: string): Promise<void> {
  const url = await ssoApi.start(provider)
  rememberSsoReturn({ kind: 'signIn', destination })
  window.location.assign(url)
}

/** Sends the browser to `provider` to connect its account to the signed-in user, returning to `returnTo`. */
export async function startSsoLink(provider: SsoProvider, returnTo: string): Promise<void> {
  const url = await ssoApi.linkStart(provider)
  rememberSsoReturn({ kind: 'link', destination: returnTo })
  window.location.assign(url)
}

function rememberSsoReturn(value: SsoReturn): void {
  sessionStorage.setItem(RETURN_KEY, JSON.stringify(value))
}

function parseSsoReturn(raw: string | null): Partial<SsoReturn> | null {
  try {
    return raw ? (JSON.parse(raw) as Partial<SsoReturn>) : null
  } catch {
    return null
  }
}

/** Reads and forgets where the round trip continues; a sign-in to `/` when nothing (valid) was remembered. */
export function takeSsoReturn(): SsoReturn {
  const raw = sessionStorage.getItem(RETURN_KEY)
  sessionStorage.removeItem(RETURN_KEY)
  const parsed = parseSsoReturn(raw)
  return {
    kind: parsed?.kind === 'link' ? 'link' : 'signIn',
    destination: safeInAppPath(parsed?.destination) ?? '/',
  }
}

/** The session-storage entry that tells the page loaded after a link that the account was connected. */
export const LINKED_SESSION_ENTRY: Record<string, string> = { [LINKED_KEY]: '1' }

/** Whether this page load follows a completed link; reading it forgets it. */
export function takeSsoLinked(): boolean {
  const linked = sessionStorage.getItem(LINKED_KEY) === '1'
  sessionStorage.removeItem(LINKED_KEY)
  return linked
}
